import {
  Grid,
  TextField,
  IconButton,
  FormLabel,
  Box,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import { Add as AddIcon, Delete as DeleteIcon } from "@mui/icons-material";
import AutocompleteWithPagination from "../autocomplete-with-pagination";

const SKURow = ({ sku, m2oData }) => {
  return (
    <Grid container spacing={2} sx={{ mb: 2, alignItems: "center" }}>
      {/* Row 1: SKUs and Quantity */}
      <Grid
        item
        xs={12}
        md={6}
        sx={{ textAlign: "left", alignItems: "center" }}
      >
        <FormLabel
          sx={{ mb: 0, mr: 2, fontSize: "0.875rem", minWidth: "100%" }}
          required
        >
          SKU
        </FormLabel>
        <AutocompleteWithPagination
          width={"100%"}
          hideLabel
          type={"fetchSku"}
          selectedClient={m2oData?.client_id}
          backgroundColor={"#FFF"}
          customLabel={"SKU"}
          selectedItem={sku.sku || null}
          onDataChange={() => {}}
          optionKey={"sku"}
          apiEndPoint={() => {}}
          disabled
          sx={{ flexGrow: 1 }}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
        sx={{ textAlign: "left", alignItems: "center" }}
      >
        <FormLabel
          sx={{ mb: 0, mr: 2, fontSize: "0.875rem", minWidth: "80px" }}
          required
        >
          Quantity Requested
        </FormLabel>
        <TextField
          fullWidth
          size="small"
          type="number"
          value={sku.quantity_requested || ""}
          onChange={() => {}}
          disabled
          sx={{ flexGrow: 1, mt: 0.5 }}
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={1}
        sx={{
          textAlign: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      ></Grid>
    </Grid>
  );
};

export default SKURow;
